/**
 * Location Wiki Route — Displays brand settings information for a location.
 *
 * Route: /_auth/location-wiki/:locationId
 * Opens in a new tab from the Patient Panel when clicking on location name.
 */

import { createFileRoute } from '@tanstack/react-router';
import { lazyRouteComponent } from '@tanstack/react-router';

// Lazy load the wiki page for code splitting
const LocationWikiPage = lazyRouteComponent(
  () => import('../../../features/location-wiki/location-wiki-page'),
  'LocationWikiPage'
);

export const Route = createFileRoute('/_auth/location-wiki/$locationId')({
  component: LocationWikiPage,
});
